import * as environmentHelper from 'js/environmentHelper';

const sn = window.sn;

export const CONSTANTS = sn?.constants;
export const ENUMS = sn?.enums;
export const MAPS = sn?.maps;
export const URLS = sn?.urls;
export const FEATURE_FLAGS = environmentHelper.featureFlags;



// WEBPACK FOOTER //
// ./common.js